var _path, _path2, _circle, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c4272f",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#015197",
    d: "M213.3 0h213.4v480H213.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 189.1,
    r: 35,
    fill: "#f9cf02"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 173.2,
    r: 38.2,
    fill: "#c4272f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9cf02",
    fillRule: "evenodd",
    d: "M91.1 131.8a15.9 15.9 0 0 0 31.8 0c0-6.3-4-7.2-4-9.5 0-2.4 2.4-5.6-2.4-9.6 2.4 4-1.6 4.8-1.6 8.8 0 4 1.6 4 1.6 7.1a3.2 3.2 0 0 1-6.3 0c0-3.1 3.1-6.3 3.1-11 0-4.9-.7-6.5-3.1-10.4-2.4-4-6.4-7.2-3.2-10.4-4.8 1.6-2.4 8-2.4 12s-3.2 6.3-3.2 11 2.4 5.7 2.4 8.8a3.2 3.2 0 0 1-6.3 0c0-3.1 1.6-3.1 1.6-7.1s-4-4.8-1.6-8.8c-4.8 4-2.4 7.2-2.4 9.6 0 2.4-4 3.1-4 9.5z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 179.5,
    r: 25.4,
    fill: "#f9cf02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9cf02",
    d: "M37 230.4v152.7h31.8V230.4zm108.2 0v152.7H177V230.4zm-70 25.5v12.7h63.6v-12.7zm0 89v12.8h63.6V345zm0-114.5h63.6L107 249.5zm0 133.7h63.6L107 383z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 306.8,
    r: 33.7,
    fill: "#f9cf02",
    stroke: "#c4272f",
    strokeWidth: 3.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c4272f",
    strokeWidth: 3.8,
    d: "M107 273a16.9 16.9 0 0 1 0 33.8 16.9 16.9 0 1 0 0 33.7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 289.9,
    r: 6.4,
    fill: "#c4272f"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 323.6,
    r: 6.4,
    fill: "#c4272f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/mn.762381a5cf171dbbe928814074ea7003.svg";
export { ForwardRef as ReactComponent };